// Zona horaria del navegador -> backend (#1301, R14).
//
// La Comunidad ubica a cada colega por país: declarado, celular o, si no hay nada de eso, la
// zona horaria del navegador. Se informa UNA vez por sesión del navegador y por cuenta, en
// silencio: sin toast, sin reintento, sin bloquear nada. El backend traduce la zona a país y
// descarta la zona (no se guarda ni se loggea); nunca se usa la IP.
// Cubre R14 — .claude/specs/1301-comunidad-globo/
import getClient from "./get-client";

export const CLAVE_ZONA_ENVIADA = "smartdx_zona_enviada_v1";

export function zonaDelNavegador() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (e) {
    return "";
  }
}

// La marca se escribe ANTES del POST: dos montajes seguidos (React StrictMode, o un refresh del
// usuario mientras la primera llamada sigue en vuelo) no deben mandar dos. Si el POST falla, se
// pierde el aviso de esta sesión y listo: se reintenta en la próxima, como pide R14.
export async function enviarZonaHorariaUnaVez(userId, cliente) {
  if (userId === undefined || userId === null || userId === "") return false;
  const clave = `${CLAVE_ZONA_ENVIADA}:${userId}`;
  try {
    if (window.sessionStorage.getItem(clave)) return false;
    const zona = zonaDelNavegador();
    if (!zona) return false;
    window.sessionStorage.setItem(clave, "1");
    await (cliente || getClient()).post("/api/user/me/zona-horaria/", { zona });
    return true;
  } catch (e) {
    return false;
  }
}
